import { DataScopesEnum, UserRightsEnum } from '../../../utilities/Constants';

import Authorization from '../../../stores/Authorization';
import { CheckmateSameCaseGroupIcon } from '../../../shared/CheckmateIcons';
import { LocalRoutes } from '../../../utilities/LocalRoutes';
import { MenuItemNavLinkWithIcon } from '../MenuItemNavLinkWithIcon';
import { useAuthContext } from '../../../contexts/AuthContext';

export function QuadNavigationMenu() {
    const { user, isLoggedIn } = useAuthContext();

    const organizationsWithAddZoneNoteRight = Authorization.getUserOrganizationsWithRight(
        UserRightsEnum.AddZoneNote,
        user
    );

    const organizationsWithTriggerRight = Authorization.getUserOrganizationsWithRight(
        UserRightsEnum.CaseTriggerRules,
        user
    );
    const organizationsWithQueryRight = Authorization.getUserOrganizationsWithRight(
        UserRightsEnum.ViewCaseList,
        user
    );

    const canViewSameCases = Authorization.isAuthorizedToRoute(LocalRoutes.QuadCaseList, user);
    const showAddZoneNoteMenuItem = organizationsWithAddZoneNoteRight.length > 1;
    const showTriggerMenuItem = organizationsWithTriggerRight.length > 1;
    const showQueryMenuItem = organizationsWithQueryRight.length > 1;

    if (!user.profile) {
        return <div className="float-end" style={{ margin: '38px' }} />;
    }

    return (
        <div
            style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                gap: '4vw',
            }}
        >
            {isLoggedIn && (
                <div className="innerContainer">
                    <button
                        className="btn-no-bg bold quad-nav-item quad-blue uppercase"
                        data-bs-toggle="dropdown"
                    >
                        <span>Quad</span>
                    </button>
                    <div
                        className="dropdown-menu adjust-left"
                        style={{ textTransform: 'uppercase' }}
                    >
                        {canViewSameCases && (
                            <MenuItemNavLinkWithIcon
                                icon={<CheckmateSameCaseGroupIcon />}
                                label="Same Cases"
                                to={LocalRoutes.QuadCaseList}
                            />
                        )}
                        <MenuItemNavLinkWithIcon
                            icon="fal fa-book-bookmark"
                            label="Case Resolution"
                            to={LocalRoutes.QuadCaseResolution}
                        />
                        {showAddZoneNoteMenuItem && (
                            <MenuItemNavLinkWithIcon
                                icon="fal fa-memo"
                                label="Add Zone Note"
                                to={LocalRoutes.QuadZoneNoteCreate}
                            />
                        )}
                        {showTriggerMenuItem && (
                            <MenuItemNavLinkWithIcon
                                icon="fal fa-memo"
                                label="Add Trigger Rule"
                                to={LocalRoutes.QuadTriggerRuleCreate}
                            />
                        )}
                        {showQueryMenuItem && (
                            <MenuItemNavLinkWithIcon
                                icon="fal fa-memo"
                                label="Search cases"
                                to={LocalRoutes.QuadQuery}
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
